/**
 * Wrap diagram images in scrollable containers on mobile
 * This prevents page-wide horizontal scroll while allowing diagram scroll
 */

(function() {
  'use strict';
  
  function wrapDiagrams() {
    // Only run on mobile/tablet screens
    if (window.innerWidth > 989) return;
    
    // Find all images with class "diagram" in the comparison article
    const diagrams = document.querySelectorAll('.comparison-article-container img.diagram');
    
    diagrams.forEach(function(img) {
      // Skip if already wrapped
      if (img.parentElement.classList.contains('diagram-scroll-wrapper')) {
        return;
      }
      
      // Create wrapper div
      const wrapper = document.createElement('div');
      wrapper.className = 'diagram-scroll-wrapper';
      
      // Insert wrapper before the image
      img.parentNode.insertBefore(wrapper, img);
      
      // Move image into wrapper
      wrapper.appendChild(img);
    });
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapDiagrams);
  } else {
    wrapDiagrams();
  }
  
  // Re-run on window resize (debounced)
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(wrapDiagrams, 250);
  });
})();

